// extracted by mini-css-extract-plugin
module.exports = {"linkVerticalPadding":"styles--linkVerticalPadding--Qs1-t","active":"styles--active--2zID0","arrow":"styles--arrow--1kXl2"};